import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white border-b border-slate-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=350,quality=90,format=auto/assets/1a874191-82d1-41a7-bad4-47bc2252f075/invest-logo-cmyk-768x119.png"
            alt="Danske Telemaster Invest"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>
      </div>
    </header>
  );
}
